import request from "./http";
import qs from 'qs'

  //统计-尖峰平谷统计
// bgTime(时间戳) deviceNos(数组) endTime(时间戳)
export function getStatisticsPG(params) {
    return request({
        url: "/rate/statisticsPG",
        method: "get",
        params,
        paramsSerializer: params => {
            return qs.stringify(params, { indices: false })
          }
    });
}

//列表查询
// 参数 temName 有参数就是搜索查询  无参数就是默认全部
export function getRateData(params) {
    return request({
        url: "/rate/tem/findList",
        method: "get",
        params,
    });
}


//删除数据
// 参数 id 模板id
export function getRateRemoById(params) {
    return request({
        url: "/rate/tem/remoById",
        method: "delete",
        params,
    });
}


//启用禁止
export function getRateEditEnableAndDisabled(params) {
    return request({
        url: "/rate/tem/editEnableAndDisabled",
        method: "put",
        params,
    });
}
//尖峰平谷配置(时间)
export function getRateTimeConfig(params) {
    return request({
        url: "/rate/getTimeConfig",
        method: "get",
        params
    });
}


// 新增模板操作
export function getRateTemSave(rateType,addName) {
    return request({
        url: "/rate/tem/save",
        method: "post",
        headers:{
            'Content-Type':'application/json',
            'Accept':'*/*'
          },
          data:{
            "energyType":rateType,
            "temName":addName
          }
    });
}


//保存尖峰平谷配置
export function getRateSectionSave(data) {
    return request({
        url: "/rate/section/save",
        method: "post",
        headers:{
            'Content-Type':'application/json',
            'Accept':'*/*'
          },
          data
    });
}
//保存月区间尖峰平谷配置
export function getRateStageSave(data) {
    return request({
        url: "/rate/stage/save",
        method: "post",
        headers:{
            'Content-Type':'application/json',
            'Accept':'*/*'
          },
          data
    });
}

//月区间查看详情
export function getRateFindSectionListByTemId(params) {
    return request({
        url: "/rate/section/findSectionListByTemId",
        method: "get",
        params,
    });
}
 

//尖峰平谷查看详情
export function getRateFindListBySectionId(params) {
    return request({
        url: "/rate/stage/findListBySectionId",
        method: "get",
        params,
    });
}

//尖峰平谷查新增模板统一保存
export function rateSaveAll(data) {
    return request({
        url: "/rate/saveAll",
        method: "post",
        headers:{
            'Content-Type':'application/json',
            'Accept':'*/*'
          },
          data
    });
}

 